module.exports = __webpack_public_path__ + "img/594-42dfb3.png";